import { render } from "./AdPage.vue?vue&type=template&id=5703eb66"
import script from "./AdPage.vue?vue&type=script&lang=js"
export * from "./AdPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__